(function () {
	'use strict';

	angular
		.module('wizard-english-test.directives')
		.directive('systemMessage', SystemMessage)

	/** @ngInject */
	function SystemMessage(PATHS) {
		function SystemMessageController($timeout) {
			const vm = this;
			console.log('vm.stepMessages: ', vm.stepMessages);

			function renderMessageOnScreen() {
				vm.isWriting = true;

				vm.stepMessages.forEach(messageGroup => {
					let messages = messageGroup.messages;

					messages.forEach(message => {
						$timeout(() => {
							vm.stepMessagesShow = message;
						}, 1000)
					});
				});
			}

			init();

			function init() {

				// renderMessageOnScreen();
			}

		}

		return {
			bindToController: true,
			controller: SystemMessageController,
			controllerAs: 'vm',
			restrict: 'AE',
			templateUrl: `${PATHS.PHYSICAL}/directives/system-message/system-message.html`,
			scope: {
				stepMessages: '='
			}
		}
	}
}());